import React, {useState} from "react";

import {Button, Divider, message, Radio} from "antd";
import {useTranslation} from "react-i18next";
import {ContainerType} from "../../../api/apiTypes";
import {showApiError, showMessage,} from "../../../common/message";
import Lottie from "lottie-react";
import spinner from "../../../assets/lotties/spinner.json";
import http from "../../../services/http.service";
import {queries} from "../../../api/queries";
import {DraggableModal} from "../../molecules/DraggableModal";

type TCreatePlanAPIData = {
  tracking_numbers: string[];
  plan_no: string;
  bunny_color: ContainerType;
  plan_date?: string;
};

interface Props {
  planNo: string;
  planDate?: string;
  trackingNumbers: string[];
  onCreated: () => void;
  onHide: () => void;
}

export const CreatetPlanPopup = ({
                                   onCreated, onHide, trackingNumbers, planNo, planDate,
                                 }: Props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const {t} = useTranslation("shipping");
  const [selectedType, setSelectType] = useState<ContainerType>();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleCreate = (e: any) => {
    if (!selectedType) {
      showMessage(messageApi, t("Please, select bunny type"), "warning");
    }
    else if (!planNo.length) {
      showMessage(messageApi, t("Please, select plan no first"), "warning");
    }
    else {
      setIsLoading(true);
      const data: TCreatePlanAPIData = {
        tracking_numbers: trackingNumbers, plan_no: planNo[0], //search params는 string 배열로 옵
        bunny_color: selectedType, plan_date: planDate?.length ? planDate[0] : undefined, //search params는 string 배열로 옵
      };
      http
      .post(queries.plan.create, data)
      .then(() => {
        onHide();
        onCreated();
      })
      .catch((error) => showApiError(error, messageApi))
      .finally(() => {
        setIsLoading(false);
      });
    }
  };
  
  const buttonNode = (<div className={"footer"}>
    <Button
      type={"text"}
      className={"cancel"}
      onClick={onHide}
    >
      {t("popup.btn.back")}
    </Button>
    <Divider type={"vertical"} className={"divider"} />
    <Button
      type={"text"}
      color={"primary"}
      className={"ok"}
      onClick={handleCreate}
    >
      {t("shipping.status.btn.create.plan")}
    </Button>
  </div>);
  
  return (<DraggableModal
    closable={false}
    cancelText={""}
    open={true}
    maskClosable
    centered
    width={305}
    className={"sm-modal"}
    classNames={{body: "body", content: "content", footer: "footer"}}
    footer={buttonNode}
  >
    {contextHolder}
    <div className={"title"}>
      {t("Plan bunny type")}
    </div>
    <Radio.Group
      onChange={(e: any) => setSelectType(e.target.value)}
      className={"radio"}
      name="radiogroup"
    >
      <Radio
        style={{marginTop: "6px"}}
        className={"item"}
        value={ContainerType.BLACK}
      >
        {ContainerType.BLACK}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerType.BLUE}
      >
        {ContainerType.BLUE}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerType.WHITE}
      >
        {ContainerType.WHITE}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerType.OFFROAD}
      >
        {ContainerType.OFFROAD}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerType.RAINBOW}
      >
        {ContainerType.RAINBOW}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerType.YELLOW}
      >
        {ContainerType.YELLOW}
      </Radio>
      
      <Radio
        className={"item"}
        value={ContainerType.ORANGE}
      >
        {ContainerType.ORANGE}
      </Radio>
    </Radio.Group>
    {isLoading && (<Lottie className={"spinner"} animationData={spinner} loop autoplay style={{height: 25}} />)}
  </DraggableModal>);
};
